import React, { useState, useRef, useEffect } from "react";
import PersonIcon from "@mui/icons-material/Person";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Badge from "@mui/material/Badge";
import MessageIcon from "@mui/icons-material/Message";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import { jwtDecode } from "jwt-decode";
import { useLoading } from "../../../../context/LoadingContext";
import AlertModal from "../../../Requirement/components/common/AlerModel";
import { fetchData } from "../../../Requirement/services/RequirementServices";
const Header = ({ clientmenu }) => {
  const navigate = useNavigate();
  const [activeUser, setActiveUser] = useState("");
  const dropdownRef = useRef(null);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [userMessageCount, setUserMessageCount] = useState(null);
  const [isProfileDropdownVisible, setIsProfileDropdownVisible] =
    useState(false);
  const [isNotificationDropdownVisible, setIsNotificationDropdownVisible] =
    useState(false);
  const [isArrowDown, setIsArrowDown] = useState(true);
  const [userInfo, setUserInfo] = useState(null);
  const { setLoading } = useLoading();
  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
  });

  const Signout = async () => {
    console.log("rrrrrrrrrr");
    setLoading(true);
    try {
      //await Auth.signOut();

      localStorage.clear();
      navigate("/login/finance-partner");
    } catch (error) {
      console.error("Error signing out: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);

        // Check if the user is a member of the AMTPL_BUYERS group
        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_FINANCE_PARTNERS")) {
          await Auth.signOut(); // Sign out the user
          navigate("/login/finance-partner");
        } else {
          setActiveUser(user.attributes.email); // Set the active user email
        }
      } catch (error) {
        await Auth.signOut(); // Sign out the user
        navigate("/login/finance-partner");
      }
    };

    checkUser();
  }, [navigate]);
  const handleSubmit = () => {
    setModal({
      show: true,
      type: "warning",
      title: "Are you sure?",
      message: "Do you want to Sign Out?",
      isConfirm: true,
      onConfirm: confirmLogout,
      onCancel: () => setModal((prev) => ({ ...prev, show: false })),
    });
  };

  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  const confirmLogout = () => {
    setModal((prev) => ({ ...prev, show: false }));
    setModal({
      show: true,
      type: "success",
      title: "Success!",
      message: "Signed out successfully.",
      autoClose: false,
      nextAction: () => {
        Signout();
      },
    });
  };

  const toggleDropdown = () => {
    setIsDropdownVisible((prev) => !prev);
    setIsArrowDown((prev) => !prev);
  };
  const clientnav = () => {
    navigate("/my-clients");
  };
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
        setIsArrowDown(true);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const checkUerMessageCount = async () => {
      try {
        const msgResponse = await fetchData({
          target: "listMessages",
          userOrder: "CreatedAt",
          orderDirection: "ASC",
          rowStart: 0,
          pageSize: 1000,
          filterTerms: {
            // ConversationID: conversation.ConversationID,
            ReceiverUserID: activeUser,
            IsRead: 0,
          },
        });
        console.log("msgResponse", msgResponse.total);

        setUserMessageCount(msgResponse.total);
      } catch (error) {
        console.error("Error checking user:", error);
      }
    };
    checkUerMessageCount();
  }, [userMessageCount]);
  const redirectToMessage = () => {
    navigate("/finance-partner/messaging");
  };
  const toggleProfileDropdown = () => {
    setIsProfileDropdownVisible((prev) => !prev);
    setIsNotificationDropdownVisible(false); // Hide notification dropdown when profile is clicked
  };
  return (
    <div className="header">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        onConfirm={modal.onConfirm}
        onCancel={modal.onCancel}
        isConfirm={modal.isConfirm}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <header>
        <div className="header-cus">
          <img
            src="/images/logo.png"
            alt="Grains Global Logo"
            className="logo"
          />
        </div>
        <div className="diplay-flex-css">
          <div className="breadcumbs">{/* <Breadcrumbs /> */}</div>
          <nav>
            <ul>
              <li ref={dropdownRef} className="profile-menu">
                <div
                  className="profile-trigger"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  {/* <Badge badgeContent={2} color="error" onClick={toggleNotificationDropdown} style={{ marginRight:'15px' }}> */}

                  {/* <Badge badgeContent={userMessageCount} onClick={redirectToMessage} color="error" style={{ marginRight: '15px'}}>
                  <MessageIcon style={{  width:'20px', color:'#4c4949da' }} />
                </Badge> */}
                  <Badge color="error">
                    <NotificationsIcon
                      style={{ width: "20px", color: "#4c4949da" }}
                    />
                  </Badge>

                  <div
                    onClick={toggleDropdown}
                    style={{
                      marginLeft: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <PersonIcon style={{ width: "20px", color: "#4c4949da" }} />
                    {activeUser}
                    {isProfileDropdownVisible ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )}
                  </div>
                </div>
                {/* <div onClick={toggleDropdown} className="profile-trigger">
                  <PersonIcon />

                  {activeUser}
                  {isArrowDown ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                </div> */}
                {isDropdownVisible && (
                  <div className="profile-dropdown">
                    <div className="dropdown-content">
                      <button onClick={handleSubmit} className="dropdown-item">
                        <ExitToAppIcon /> Sign Out
                      </button>
                    </div>
                  </div>
                )}
              </li>
            </ul>
          </nav>
        </div>
      </header>
    </div>
  );
};

export default Header;
